<template>
  <div>
    <!-- Header Card -->
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-body p-15 p-sm-20 p-md-25">
        <h3 class="text-lg font-semibold">{{ deliveryNote.note_ref }}</h3>
        <p class="mt-2 text-gray-600">
          Date de création :
          <b v-if="deliveryNote.created_at">{{
            getDate(deliveryNote.created_at)
          }}</b>
          | Client : <b> {{ deliveryNote.note_customer_name }} </b>
        </p>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flex-wrap gap-2 justify-content-end mt-3">
              <!-- Save Button -->
              <template
                v-if="
                  deliveryNote.note_saved != 1 &&
                  deliveryNote.note_total_parcel != 0
                "
              >
                <button
                  class="btn btn-bluecol"
                  style="
                    border-color: #7367f0 !important;
                    background-color: #7367f0 !important;
                    color: #fff !important;
                  "
                  @click="SaveDelivery"
                  :disabled="load_save"
                >
                  <i
                    class="flaticon-diskette lh-1 me-8 position-relative top-1"
                  ></i>
                  Enregistrer
                  <div
                    class="spinner-border spinner-border-sm ms-1"
                    role="status"
                    v-if="load_save"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </button>
              </template>

              <!-- Print Button -->
              <button
                v-if="
                  deliveryNote.note_saved != 0 &&
                  deliveryNote.note_total_parcel != 0
                "
                class="btn btn-warning"
                @click="GetPDF(deliveryNote)"
              >
                <i
                  class="flaticon-printer lh-1 me-8 position-relative top-1"
                ></i>
              </button>

              <!-- Ticket Button -->
              <button
                v-if="
                  deliveryNote.note_saved != 0 &&
                  deliveryNote.note_total_parcel != 0
                "
                class="btn btn-success"
                @click="GetTicketPDF(deliveryNote)"
              >
                <i class="flaticon-menu lh-1 me-8 position-relative top-1"></i>
              </button>

              <!-- Ticket4 Button -->
              <button
                v-if="
                  deliveryNote.note_saved != 0 &&
                  deliveryNote.note_total_parcel != 0
                "
                class="btn btn-info"
                @click="GetTicket4PDF(deliveryNote)"
              >
                <i
                  class="flaticon-more-1 lh-1 me-8 position-relative top-1"
                ></i>
              </button>

              <!-- Open Button -->
              <template
                v-if="
                  deliveryNote.note_saved != 0 &&
                  deliveryNote.note_total_parcel != 0
                "
              >
                <button
                  class="btn btn-primary"
                  @click="OpenBL(deliveryNote.id)"
                  :disabled="load_open"
                >
                  <i
                    class="flaticon-unlock lh-1 me-8 position-relative top-1"
                  ></i>
                  Ouvrir
                  <div
                    class="spinner-border spinner-border-sm ms-1"
                    role="status"
                    v-if="load_open"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Liste des nouveaux colis -->
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="border-b p-4">
        <h3 class="text-lg font-semibold">Liste des nouveaux colis</h3>
      </div>
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <div class="d-sm-flex align-items-center">
          <button
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            type="button"
            v-if="deliveryNote.note_saved == 0"
            @click="addNewColis"
            :disabled="load_save"
          >
            <span
              v-if="load_save"
              class="spinner-border spinner-border-sm me-2"
              role="status"
            ></span>
            <span>{{ load_save ? "Ajout en cours..." : "Ajouter" }}</span>
            <i
              v-if="!load_save"
              class="flaticon-plus position-relative ms-5 fs-12"
            ></i>
          </button>
        </div>
        <div class="d-flex align-items-center">
          <input
            type="text"
            v-model="searchTerm1"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
          />
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="d-flex align-items-center mb-20">
          <label class="me-2 text-paragraph fw-medium">Afficher :</label>
          <select
            class="form-select form-select-sm w-auto"
            v-model="users.per_page"
            @change="getRows1"
          >
            <option :value="10">10</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
            <option :value="500">500</option>
          </select>
          <span class="ms-2 text-paragraph">lignes</span>
        </div>
        <vue-good-table
          :columns="columns"
          :rows="rows1"
          :row-key="'id'"
          :select-options="{
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          }"
          @selected-rows-change="selectionChanged"
          @select-all="onSelectAll"
        >
          <template #emptystate>
            <div class="text-center py-4 text-gray">
              Aucune entrées correspondants trouvés
            </div>
          </template>

          <template #table-row="props">
            <template v-if="props.column.field === 'code'">
              <h6 class="text-warning" v-if="props.row.replace == 1">
                {{ props.row.code }}
                <i class="flaticon-refresh"></i>
              </h6>
              <h6 class="text-info" v-else-if="props.row.partial == 1">
                {{ props.row.code }}
                <i class="flaticon-corner-down-left"></i>
              </h6>
              <h6 v-else>
                {{ props.row.code }}
              </h6>
            </template>

            <template v-else-if="props.column.field === 'status'">
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{ '--dynamic-bg': props.row.statut.code_color }"
              >
                {{ props.row.statut.s_name }}
              </div>
              <!-- <div class="text-nowrap" :style="{'color': props.row.code_color}">
                <b>{{props.row.status}}</b>       
              </div> -->
            </template>
            <template v-else-if="props.column.field === 'price'">
              <b>{{ props.row.price }}</b> DH
            </template>
            <template v-else-if="props.column.field === 'updated_at'">
              <span class="text-nowrap">
                {{ getDate(props.row.updated_at) }}
              </span>
            </template>

            <template v-else-if="props.column.field === 'created_at'">
              <span class="text-nowrap">
                {{ getDate(props.row.created_at) }}
              </span>
            </template>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>

        <PaginatorContent
          :pagination="users"
          @paginate="getRows1"
          :offset="9"
        />
      </div>
    </div>

    <!-- Liste des colis ajoutés -->
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="border-b p-4">
        <h3 class="text-lg font-semibold">Liste des colis ajoutés</h3>
      </div>
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <div class="d-sm-flex align-items-center">
          <button
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            type="button"
            v-if="deliveryNote.note_saved == 0"
            @click="removeNewColis"
            :disabled="load_save"
          >
            <span
              v-if="load_save"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>

            <span>{{ load_save ? "Suppression..." : "Supprimer" }}</span>

            <i
              v-if="!load_save"
              class="flaticon-delete position-relative ms-5 fs-12"
            ></i>
          </button>
        </div>
        <div class="d-flex align-items-center">
          <input
            type="text"
            v-model="searchTerm2"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
          />
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="d-flex align-items-center mb-20">
          <label class="me-2 text-paragraph fw-medium">Afficher :</label>
          <select
            class="form-select form-select-sm w-auto"
            v-model="users2.per_page"
            @change="getRows2"
          >
            <option :value="10">10</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
            <option :value="500">500</option>
          </select>
          <span class="ms-2 text-paragraph">lignes</span>
        </div>
        <vue-good-table
          :search-options="{ enabled: true, externalQuery: searchTerm2 }"
          :columns="columns"
          :row-key="'id'"
          :rows="rows2"
          responsive
          :select-options="{
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          }"
          @select-all="onSelectAllColis"
          @selected-rows-change="selectionChangedColis"
        >
          <template #emptystate>
            <div class="text-center py-4 text-gray">
              Aucune entrées correspondants trouvés
            </div>
          </template>

          <template #table-row="props">
            <template v-if="props.column.field === 'code'">
              <h6 class="text-warning" v-if="props.row.replace == 1">
                {{ props.row.code }}
                <i class="flaticon-refresh"></i>
              </h6>
              <h6 class="text-info" v-else-if="props.row.partial == 1">
                {{ props.row.code }}
                <i class="flaticon-corner-down-left"></i>
              </h6>
              <h6 v-else>
                {{ props.row.code }}
              </h6>
            </template>

            <template v-else-if="props.column.field === 'price'">
              <b>{{ props.row.price }}</b> DH
            </template>

            <template v-else-if="props.column.field === 'status'">
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{ '--dynamic-bg': props.row.statut.code_color }"
              >
                {{ props.row.statut.s_name }}
              </div>
            </template>

            <template v-else-if="props.column.field === 'created_at'">
              <span class="text-nowrap">
                {{ getDate(props.row.created_at) }}
              </span>
            </template>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <PaginatorContent
          :pagination="users2"
          @paginate="getRows2"
          :offset="9"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
// import PaginatorContent from "@/components/PaginatorContent.vue";

export default defineComponent({
  name: "EditNote",

  components: {
    // CreateNewUserModal,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const route = useRoute();
    const auth = useAuthStore();
    const user = auth.user;

    // props / states
    const deliveryNote = ref<any>({});

    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const direction = ref("ltr");

    // dummy columns and rows
    const columns = ref([
      {
        label: "Code Suivi",
        field: "code",
      },
      {
        label: "Destinataire",
        field: "receiver",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Prix",
        field: "price",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Statut",
        field: "status",
      },
    ]);

    const selectedRows = ref([]);
    const selectedNewRows = ref([]);

    const rows1 = ref([]);
    const rows2 = ref([]);

    const users = ref({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users2 = ref({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    const offset = ref(9);
    const isLoader2 = ref(false);
    const isLoader1 = ref(false);
    const load_save = ref(false);
    const load_open = ref(false);

    // methods
    const getDate = (date) =>
      new Date(date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    function selectionChanged(params) {
      selectedRows.value = params.selectedRows;
    }

    function onSelectAll(params) {
      selectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params) {
      console.log(params);

      selectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params) {
      console.log(params);
      selectedNewRows.value = params.selectedRows;
    }

    const fetchData = async () => {
      try {
        const res = await api.get(`/api/auth/client/show_delivery_note`, {
          params: { ref: route.params.refNote },
        });
        deliveryNote.value = res.data; // update reactive ref
      } catch (err) {
        console.error("Erreur lors du chargement du bon:", err);
      }
    };

    const getRows1 = async (page = 1) => {
      try {
        isLoader1.value = true;
        users.value.current_page = page; // ✅ update the current page

        const res = await api.get(
          `/api/auth/client/colis_list_pickedup?searchTerm=${users.value.searchTerm}&page=${users.value.current_page}&per_page=${users.value.per_page}`
        );

        rows1.value = res.data.colis.data;
        users.value = res.data.colis;
      } catch (err) {
        console.error("Erreur lors du chargement du bon:", err);
      } finally {
        isLoader1.value = false;
      }
    };

    const getRows2 = async (page = 1) => {
      isLoader2.value = true;
      users2.value.current_page = page; // ✅ update the current page
      try {
        const res = await api.get(
          `/api/auth/client/colis_indelivery_note?searchTerm=${users2.value.searchTerm}&page=${users2.value.current_page}&per_page=${users2.value.per_page}`,
          {
            params: {
              note_id: route.params.id,
              note_ref: route.params.refNote,
            },
          }
        );
        rows2.value = res.data.colis.data;
        users2.value = res.data.colis;
      } catch (err) {
        console.error("Erreur lors du chargement du bon:", err);
      } finally {
        isLoader2.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
      getRows1();
      getRows2();
    });

    // Add new colis to delivery note
    async function addNewColis() {
      if (selectedRows.value.length === 0) {
        showToast("Vous pouvez pas ajouter à ce bon de livraison", "error");
        return;
      }
      const data = new FormData();
      data.append("colis", JSON.stringify(selectedRows.value));
      data.append("id_BL", deliveryNote.value.id);
      data.append("refBL", deliveryNote.value.note_ref);
      data.append("note_customer", deliveryNote.value.note_customer);

      load_save.value = true;
      try {
        const res = await api.post("/api/auth/client/AddColisToBL", data);
        if (res.data.message === "success") {
          showToast("Ajouté avec succès", "success");
          selectedRows.value = [];
          fetchData();
          getRows1();
          getRows2();
        } else {
          showToast("Erreur lors de l'ajout", "error");
        }
      } catch (err) {
        showToast("Something went wrong! Please try again", "error");
      } finally {
        load_save.value = false;
      }
    }

    // Remove colis from delivery note
    async function removeNewColis() {
      if (selectedNewRows.value.length === 0) {
        showToast("Vous pouvez pas supprimer de ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("colis", JSON.stringify(selectedNewRows.value));
      data.append("ref_note", deliveryNote.value.note_ref);
      data.append("note_id", deliveryNote.value.id);

      load_save.value = true;
      try {
        const res = await api.post("/api/auth/client/RemoveColisToBL", data);
        if (res.data.message === "success") {
          showToast("Supprimé avec succès", "success");
          selectedNewRows.value = [];
          fetchData();
          getRows1();
          getRows2();
        } else {
          showToast("Erreur lors de la suppression", "error");
        }
      } catch (err) {
        showToast("Something went wrong! Please try again", "error");
      } finally {
        load_save.value = false;
      }
    }

    // Save delivery note
    async function SaveDelivery() {
      const data = new FormData();
      data.append("id_ref", deliveryNote.value.id);
      data.append("cstmr", deliveryNote.value.note_customer);

      load_save.value = true;
      try {
        const res = await api.post("/api/auth/client/SaveDelivery", data);
        if (res.data.message === "success") {
          fetchData();
          showToast("Bon de livraison est bien enregistré", "success");
        } else if (res.data.message === "error note") {
          showToast("Vous pouvez pas enregistrer ce bon", "error");
        } else {
          showToast("Something went wrong! Please try again", "error");
        }
      } catch (err) {
        showToast("Something went wrong! Please try again", "error");
      } finally {
        load_save.value = false;
      }
    }

    // Get PDF
    async function GetPDF(row) {
      try {
        const response = await api.get(`/api/auth/client/DELPDF/${row.id}`, {
          responseType: "arraybuffer",
        });
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        window.open(link.href, "_blank");
      } catch (err) {
        showToast("Erreur lors de la génération du PDF", "error");
      }
    }

    // Get Ticket PDF
    async function GetTicketPDF(row) {
      try {
        const response = await api.get(
          `/api/auth/client/TicketsPDF/${row.id}`,
          {
            responseType: "arraybuffer",
          }
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        window.open(link.href, "_blank");
      } catch (err) {
        showToast("Erreur lors de la génération du ticket PDF", "error");
      }
    }

    // Get Ticket 4 PDF
    async function GetTicket4PDF(row) {
      try {
        const response = await api.get(
          `/api/auth/client/Tickets4PDF/${row.id}`,
          {
            responseType: "arraybuffer",
          }
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        window.open(link.href, "_blank");
      } catch (err) {
        showToast("Erreur lors de la génération du ticket PDF", "error");
      }
    }

    // Open BL
    async function OpenBL(id) {
      const data = new FormData();
      load_open.value = true;
      try {
        const res = await api.post(`/api/auth/client/OpenBL/${id}`, data);
        if (res.data.message === "success") {
          showToast("Bon de livraison est bien ouvert", "success");
          fetchData();
          getRows1();
          getRows2();
        } else if (res.data.message === "no edit") {
          showToast("Vous pouvez pas ouvrir ce bon", "error");
        } else {
          showToast("Something went wrong! Please try again", "error");
        }
      } catch (err) {
        showToast("Something went wrong! Please try again", "error");
      } finally {
        load_open.value = false;
      }
    }

    return {
      auth,
      deliveryNote,
      columns,
      rows2,
      rows1,
      getDate,
      addNewColis,
      removeNewColis,
      onSelectAll,
      selectionChanged,
      selectionChangedColis,
      onSelectAllColis,
      searchTerm1,
      searchTerm2,
      direction,
      selectedNewRows,
      selectedRows,
      users,
      users2,
      getRows1,
      getRows2,
      isLoader1,
      isLoader2,
      load_save,
      load_open,
      SaveDelivery,
      GetPDF,
      GetTicketPDF,
      GetTicket4PDF,
      OpenBL,
    };
  },
});
</script>